// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"131807f9","1357":"b98045df","7641":"0e27f0f1","9196":"6d9b2951","9608":"6d9b2951","9954":"a0248249"}[chunkId] + ".chunk.css";
};